import Vue from 'vue'

/**
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 *
 * Reject casualty photos
 *
 * @param  payload ID Array and comment
 * @return {Array} File's info
 */

const rejectEvidencePhotos = payload =>
  Vue.$http.post('catalogs/common/reject/concept-file/', payload)
    .then()
    .catch((err) => {
      throw err
    })

export default rejectEvidencePhotos


// WEBPACK FOOTER //
// ./src/services/workPlan/rejectEvidencePhotos.js